"use client";

import React from "react";
import BlogRedirectLoader from "./BlogRedirectLoader";

interface RedirectHandlerProps {
  redirectUrl?: string;
  children: React.ReactNode;
}

/**
 * Client component to handle redirects with loader display
 */
export default function RedirectHandler({ redirectUrl, children }: RedirectHandlerProps) {
  const [showLoader, setShowLoader] = React.useState(!!redirectUrl);
  
  React.useEffect(() => {
    if (redirectUrl) {
      // Show loader immediately
      setShowLoader(true);
      
      // Redirect after a brief delay to ensure loader is visible
      const timer = setTimeout(() => {
        window.location.href = redirectUrl;
      }, 150);
      
      return () => clearTimeout(timer);
    } else {
      // Hide loader once content is ready
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [redirectUrl]);

  return (
    <>
      {showLoader && <BlogRedirectLoader />}
      {children}
    </>
  );
}
